import App from "App";
import Deals from "pages/apps/crm/Deals";
import LeadsAI from "pages/apps/crm/LeadsAI";
import MainLayout from "layouts/MainLayout";
import Error404 from "pages/error/Error404";
import Reports from "pages/apps/crm/Reports";
import AddLead from "pages/apps/crm/AddLead";
import EditLead from "pages/apps/crm/EditLead";
import Crm from "pages/dashboard/Crm";
import SmartCMAReports from "pages/apps/crm/SmartCMAReports";
import SmartCMAReportDetails from "pages/apps/crm/SmartCMAReportDetails";
import Chat from "pages/apps/chat/Chat";
import Emails from "pages/apps/crm/Emails";
import Calendars from "pages/apps/crm/Calendars";
import Analytics from "pages/apps/crm/Analytics";
import LeadDetails from "pages/apps/crm/LeadDetails";
import DealDetails from "pages/apps/crm/DealDetails";
import EmailSetting from "pages/apps/crm/EmailSetting";
import SomethingWrong from "pages/error/SomethingWrong";
import Collaborators from "pages/apps/crm/Collaborators";
import ReportDetails from "pages/apps/crm/ReportDetails";
import ProfileSettings from "pages/apps/crm/ProfileSettings";
import MainLayoutProvider from "providers/MainLayoutProvider";
import SecuritySettings from "pages/apps/crm/SecuritySettings";
import CardSignIn from "pages/pages/authentication/card/SignIn";
import CardSignOut from "pages/pages/authentication/card/SignOut";
import InternalOnboarding from "pages/apps/crm/InternalOnboarding";
import Onboarding from "pages/pages/authentication/card/Onboarding";
import SignUpPaid from "pages/pages/authentication/card/SignUpPaid";
import ProtectedRoute from "components/protected-route/ProtectedRoute";
import PricePredictionModel from "pages/apps/crm/PricePredictionModel";
import SubscriptionSettings from "pages/apps/crm/SubscriptionSettings";
import { Navigate, RouteObject, createBrowserRouter } from "react-router-dom";
import CardResetPassword from "pages/pages/authentication/card/ResetPassword";
import CardForgotPassword from "pages/pages/authentication/card/ForgotPassword";
import ConnectNewEmail from "components/modules/crm/email-settings/ConnectNewEmail";
import SmartCMAWorkflow from "components/smart-cma-workflow/SmartCMAWorkflow";
import MarketIntelligencePage from "pages/MarketIntelligencePage";

const routes: RouteObject[] = [
  {
    element: <App />,
    children: [
      {
        index: true,
        element: <Navigate to="/sign-in" replace />,
      },
      {
        path: "/",
        element: (
          <MainLayoutProvider>
            <MainLayout />
          </MainLayoutProvider>
        ),
        children: [
          {
            path: "/",
            children: [
              {
                path: "dashboard",
                element: (
                  <ProtectedRoute>
                    <Crm />
                  </ProtectedRoute>
                ),
              },
              {
                path: "analytics",
                element: (
                  <ProtectedRoute>
                    <Analytics />
                  </ProtectedRoute>
                ),
              },
              {
                path: "deals",
                element: (
                  <ProtectedRoute>
                    <Deals />
                  </ProtectedRoute>
                ),
              },
              {
                path: "deals/:id",
                element: (
                  <ProtectedRoute>
                    <DealDetails />
                  </ProtectedRoute>
                ),
              },
              {
                path: "report-details",
                element: (
                  <ProtectedRoute>
                    <ReportDetails />
                  </ProtectedRoute>
                ),
              },
              {
                path: "leads",
                element: (
                  <ProtectedRoute>
                    <LeadsAI />
                  </ProtectedRoute>
                ),
              },
              {
                path: "edit-lead/:id",
                element: (
                  <ProtectedRoute>
                    <EditLead />
                  </ProtectedRoute>
                ),
              },
              {
                path: "leads/:id",
                element: (
                  <ProtectedRoute>
                    <LeadDetails />
                  </ProtectedRoute>
                ),
              },
              {
                path: "reports",
                element: (
                  <ProtectedRoute>
                    <Reports />
                  </ProtectedRoute>
                ),
              },
              {
                path: "add-lead",
                element: (
                  <ProtectedRoute>
                    <AddLead />
                  </ProtectedRoute>
                ),
              },
              // {
              //   path: "add-deal",
              //   element: (
              //     <ProtectedRoute>
              //       <AddDeal />
              //     </ProtectedRoute>
              //   ),
              // },
              {
                path: "collaborators",
                element: (
                  <ProtectedRoute>
                    <Collaborators />
                  </ProtectedRoute>
                ),
              },
              // The Settings menu is defined in sitemap.tsx
              // We don't need to define it here in Routes.tsx
              // This prevents TypeScript errors since RouteObject doesn't support custom properties
              // like 'name', 'icon', etc.
              {
                path: "price-prediction-model",
                element: (
                  <ProtectedRoute>
                    <PricePredictionModel />
                  </ProtectedRoute>
                ),
              },
              {
                path: "smart-cma-reports",
                element: (
                  <ProtectedRoute>
                    <SmartCMAReports />
                  </ProtectedRoute>
                ),
              },
              {
                path: "smart-cma-report/:reportId",
                element: (
                  <ProtectedRoute>
                    <SmartCMAReportDetails />
                  </ProtectedRoute>
                ),
              },
              {
                path: "smart-cma-workflow",
                element: (
                  <ProtectedRoute>
                    <SmartCMAWorkflow />
                  </ProtectedRoute>
                ),
              },
              {
                path: "market-intelligence",
                element: (
                  <ProtectedRoute>
                    <MarketIntelligencePage />
                  </ProtectedRoute>
                ),
              },
              {
                path: "chat",
                element: (
                  <ProtectedRoute>
                    <Chat />
                  </ProtectedRoute>
                ),
                children: [
                  {
                    index: true,
                    element: <Chat />,
                  },
                ],
              },
              {
                path: "/",
                children: [
                  {
                    path: "/settings/email-settings",
                    element: <ProtectedRoute><EmailSetting /></ProtectedRoute>,
                  },
                  {
                    path: "/email-settings/new-email",
                    element: <ProtectedRoute><ConnectNewEmail /></ProtectedRoute>,
                  },
                  {
                    path: "/emails",
                    element: <ProtectedRoute><Emails /></ProtectedRoute>,
                  },
                  {
                    path: "/calendars",
                    element: <ProtectedRoute><Calendars /></ProtectedRoute>,
                  },
                ],
              },
              {
                path: "settings/profile-settings",
                element: (
                  <ProtectedRoute>
                    <ProfileSettings />
                  </ProtectedRoute>
                ),
              },
              {
                path: "settings/security-settings",
                element: (
                  <ProtectedRoute>
                    <SecuritySettings />
                  </ProtectedRoute>
                ),
              },
              {
                path: "settings/subscription-settings",
                element: (
                  <ProtectedRoute>
                    <SubscriptionSettings />
                  </ProtectedRoute>
                ),
              },
              {
                path: "settings/onboarding",
                element: (
                  <ProtectedRoute>
                    <InternalOnboarding />
                  </ProtectedRoute>
                ),
              },
            ],
          },
        ],
      },
      {
        path: "/",
        children: [
          {
            path: "sign-up-paid",
            element: <SignUpPaid />,
          },
          {
            path: "onboarding",
            element: <Onboarding />,
          },
          {
            path: "sign-in",
            element: <CardSignIn />,
          },
          // {
          //   path: "sign-up",
          //   element: <CardSignUp />,
          // },
          {
            path: "sign-out",
            element: <CardSignOut />,
          },
          {
            path: "forgot-password",
            element: <CardForgotPassword />,
          },
          {
            path: "reset-password",
            element: <CardResetPassword />,
          },
          {
            path: "cancel",
            element: <SomethingWrong />,
          },
          {
            path: "*",
            element: <Error404 />,
          },
        ],
      },
    ],
  },
];

export const router = createBrowserRouter(routes);

export default routes;
